import { render, staticRenderFns } from "./Thirty_percent.vue?vue&type=template&id=6ad00704&scoped=true"
import script from "./Thirty_percent.vue?vue&type=script&lang=js"
export * from "./Thirty_percent.vue?vue&type=script&lang=js"
import style0 from "./Thirty_percent.vue?vue&type=style&index=0&id=6ad00704&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ad00704",
  null
  
)

export default component.exports